import { ThemeColors } from '../theme-colors';

// Used in Input, Textarea, (maybe datepicker)
export const Input = {
	inputBorder: 'var(--epods--color-border)',
	inputFill: 'var(--epods--color-bg-input)',
	inputFillError: 'var(--epods--color-signal-error-bg)',
	inputFillDisabled: 'var(--epods--color-bg-input)',
	inputFillActive: 'var(--epods--color-bg-input)',
	inputFillPositive: 'var(--epods--color-signal-success-bg)',
	inputFillWarning: 'var(--epods--color-signal-warning-bg)',
	inputFillReadOnly: 'var(--epods--color-bg-input-readonly)',
	inputTextDisabled: 'var(--epods--color-text-disabled)',
	inputBorderError: 'var(--epods--color-signal-error-border)',
	inputBorderPositive: 'var(--epods--color-signal-success-border)',
	inputBorderWarning: 'var(--epods--color-signal-warning-border)',
	inputEnhancerFill: '#EEEEEE', // TODO: dont know what it is
	inputEnhancerFillDisabled: '#EEEEEE', // TODO: dont know what it is
	inputEnhancerTextDisabled: '#AFAFAF', // TODO: dont know what it is
	inputPlaceholder: 'var(--epods--color-text-disabled)',
	inputPlaceholderDisabled: 'var(--epods--color-text-disabled)',
};

export const CustomInput = {
	inputHeight: 'var(--epods--height-input)',
	inputColorHeight: 'var(--epods--height-color-input)',
	inputBorderWidth: 'var(--epods--border-width-input)',
	inputHoverBorder: 'var(--epods--color-border)',
	inputFocusWidth: 'var(--epods--focus-width-input)',
	inputPaddingLeftIconBefore: 'var(--epods--padding-left-iconBefore-input)',
	inputPaddingRightIconBefore: 'var(--epods--padding-right-iconBefore-input)',
	inputPaddingRightIconAfter: 'var(--epods--padding-right-iconAfter-input)',
	inputPaddingTopBottom: 'var(--epods--padding-topBottom-input)',
	inputPaddingSide: 'var(--epods--padding-left-input)',
	inputColorHeightP: 'var(--epods--padding-color-height-input)',
};

export const CustomTextareaColors = {
	textareaTextColor: 'var(--epods--color-text-primary)',
	textareaPlaceholderColor: 'var(--epods--color-text-disabled)',
};

export const CustomTextarea = {
	inputBorderWidth: 'var(--epods--border-width-input)',
	inputFocusWidth: 'var(--epods--focus-width-input)',
	textSize: 'var(--epods--textarea-text-size)',
	textHeight: 'var(--epods--textarea-text-height)',
	paddingTop: 'var(--epods--textarea-padding-top)',
	paddingBottom: 'var(--epods--textarea-padding-bottom)',
	paddingRight: 'var(--epods--textarea-padding-right)',
	paddingLeft: 'var(--epods--textarea-padding-left)',
};
